export const ANT_TABLE_SORT_ASC = 'ascend';
export const ANT_TABLE_SORT_DESC = 'descend';

export const SORT_TYPES_MAP = {
	[ANT_TABLE_SORT_ASC]: 'ASC',
	[ANT_TABLE_SORT_DESC]: 'DESC'
};